import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-invite-register',
  templateUrl: './invite-register.component.html',
  styleUrls: ['./invite-register.component.css']
})
export class InviteRegisterComponent {

  constructor(private router: Router) {
  }

  register() {
    this.router.navigate(['/register']);
  }
}
